module.exports = __webpack_public_path__ + "static/img/hand.6bef52ea.jpg";